import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IframeService {
	private iframeUrl: BehaviorSubject<string> = new BehaviorSubject(null);

	constructor() {}

	get urlIframeUrl(): Observable<string> {
		return this.iframeUrl.asObservable();
	}

	setUrlIframe(url: string): void {
		this.iframeUrl.next(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/helpers/iframe-service/iframe.service.ts